{
  "contact-details": {
    "email": "Tuatusi imeli",
    "mobilePhone": "Telefoni fe‘avea‘i",
    "nextLabel": "$t(common:next): <b>Lau foma‘i GP (dokita)</b>",
    "otherPhone": "Isi telefoni`",
    "text": "O lo‘o matou fa‘aaogā nei fa‘amatalaga e fa‘afeso‘ota‘i atu ai, ae e mafai ona e suia pe a mana‘omia.",
    "title": "Lau fa‘amatalaga feso‘ota‘i"
  },
  "doctor": {
    "gp": "Igoa o le foma‘i GP (dokita)",
    "manually": "E le o fa‘aalia le foma‘i? <PrimaryText>Ulufale i le lima...</PrimaryText>",
    "medicalCentre": "Nofoaga Foma‘i`",
    "nextLabel": "$t(common:next): <b>Lau fa‘afeso‘ota‘i fa‘alavelave fa‘afuase‘i</b>",
    "searchPlaceholder": "Su‘esu‘e lau foma‘i GP po o le nofoaga foma‘i",
    "text": "O lau foma‘i GP lea? Afai e leai, fa‘amolemole fa‘afou.",
    "title": "Lau foma‘i GP (dokita)"
  },
  "emergency": {
    "fullName": "Igoa atoa",
    "mobileNumber": "Numera feavea‘i",
    "nextLabel": "$t(common:next): <b>Inisiua / o ai e totogiina</b>",
    "relationship": "Sootaga iate oe",
    "select": {
      "child": "Tamaiti",
      "friend": "Uō",
      "other": "Isi",
      "parent": "Mātua",
      "spouse": "To‘alua / Pa‘aga"
    },
    "text": "O ai e tatau ona matou fa‘afeso‘ota‘i i se fa‘alavelave fa‘afuase‘i?",
    "title": "Lau fa‘afeso‘ota‘i mo fa‘alavelave fa‘afuase‘i"
  },
  "home-address": {
    "building": "Lavelua, fola, po‘o le iunite o le fale po‘o le vaega o fanua tetele",
    "city": "Taulaga/A‘ai",
    "manually": "Le o fa‘aalia le tuatusi? <PrimaryText>Ulufale i lima...</PrimaryText>",
    "nextLabel": "$t(common:next): <b>O au fa‘amatalaga fa‘afeso‘ota‘i</b>",
    "postcode": "Numera o le meli",
    "searchPlaceholder": "Su‘e tuatusi i Niu Sila",
    "street": "Igoa ma le numera o le auala",
    "suburb": "Pitonu‘u po‘o le RD (Tupe Fa‘ato‘aga)",
    "text": "Fa‘amolemole, ulufale mai lou tuatusi o le fale:",
    "textSecondary": "O le tuatusi lenei o le a matou fa‘aaogā:",
    "title": "Lou tuatusi o le fale"
  },
  "name-birthdate": {
    "birthDate": "Aso fanau",
    "dateFormat": "dd/mm/yyyy",
    "familyName": "Igoa o le ‘ĀIGA:",
    "firstName": "Igoa muamua",
    "nextLabel": "$t(common:next): <b>Lau NHI ma lou tulaga o le nonofo ai</b>",
    "preferredName": "Igoa e fiafia e fa‘aaogā",
    "select": {
      "label": "Sui igoa",
      "mr": "Mr",
      "ms": "Ms",
      "mx": "Mx",
      "placeholder": "Filifili lau sui igoa"
    },
    "text": "Fa‘amolemole siaki nei fa‘amatalaga ma fa‘afou soʻo se mea o lo‘o misia pe sese:",
    "title": "Lau igoa ma le aso fanau"
  },
  "nhi-residency": {
    "nextLabel": "$t(common:next): <b>Lau tuatusi o le fale</b>",
    "nhiNumber": "Numera NHI (National Health Index)",
    "resident": "O oe o se tagata nō Niu Sila?",
    "residentText": "Afai e le o oe o se tagata nō Niu Sila, atonu e tatau ona e totogiina nisi o auaunaga e pei o su‘esu‘ega i le falema‘i.",
    "text": "Fa‘amolemole siaki ma fa‘afou soʻo se mea o lo’o misia pe sese:",
    "title": "Lau numera NHI ma lou tulaga o le nonofo ai i Niu Sila"
  }
}
